import classes from "src/pages/Home/components/Forms/ExemptionPropertyDamagedForm/ExemptionPropertyDamaged.module.scss";
import { useSelectedFormContext } from "../../../../../context/SelectedForm/selected-form-context";
import { useEffect, useState, useMemo } from "react";
import {
  getSelectedFormDataHelper,
  getSelectedFormEntryDataHelper,
  saveFormHelper,
} from "../../../../../context/SelectedForm/selected-form-context.helper";
import {
  IFormEntryModel,
} from "../../../../../interfaces/form-entry.interface";
import {
  IFormFiledInterface,
} from "../../../../../interfaces/form-filed.interface";
import { useNavigate } from "react-router-dom";
import {
  IFormSettingModel,
} from "../../../../../interfaces/form-settings.interface";
import { Dialog } from "@progress/kendo-react-dialogs";
import { SelectedFormActionsEnum } from "../../../../../context/SelectedForm/selected-form-actions";
import { useFormContext } from "../../../../../context/Form/form-context";
import {
  onLoadForms
} from "../../../../../context/Form/form-helper";
import { CustomLoader } from "../../../../../components";
import { FormActionsEnum } from "../../../../../context/Form/form-actions";
import { useCallbackPrompt } from "../../../../../hooks/useCallbackPrompt";
import UnsavedFormDialog from "../../../../../components/CustomDialogs/UnsavedFormDialog/UnsavedFormDialog";
import { t } from "i18next";
import AuthService from 'src/services/authentication.service';
import { TemporaryExemptionPropertyDamagedbyDisasterFormName } from "src/constants/form-names-constants";
import { useFormSectionDataFields } from "../useFormSectionDataFields";
import { IExemptionPropertyDamagedFormFifthSection, ExemptionPropertyDamagedFormFifthSectionInterface } from "src/interfaces/forms/ExemptionPropertyDamagedByDisasterForm/exemption-property-damaged-fifth-section.interface";
import { IExemptionPropertyDamagedFormFirstSection, ExemptionPropertyDamagedFormFirstSectionInterface } from "src/interfaces/forms/ExemptionPropertyDamagedByDisasterForm/exemption-property-damaged-first-section.interface";
import { IExemptionPropertyDamagedFormFourthSection, ExemptionPropertyDamagedFormFourthSectionInterface } from "src/interfaces/forms/ExemptionPropertyDamagedByDisasterForm/exemption-property-damaged-fourth-section.interface";
import { IExemptionPropertyDamagedFormSecondSection, ExemptionPropertyDamagedFormSecondSectionInterface } from "src/interfaces/forms/ExemptionPropertyDamagedByDisasterForm/exemption-property-damaged-second-section.interface";
import { IExemptionPropertyDamagedFormSeventhSection, ExemptionPropertyDamagedFormSeventhSectionInterface } from "src/interfaces/forms/ExemptionPropertyDamagedByDisasterForm/exemption-property-damaged-seventh-section.interface";
import { IExemptionPropertyDamagedFormSixthSection, ExemptionPropertyDamagedFormSixthSectionInterface } from "src/interfaces/forms/ExemptionPropertyDamagedByDisasterForm/exemption-property-damaged-sixth-section.interface";
import { IExemptionPropertyDamagedFormThirdSection, ExemptionPropertyDamagedFormThirdSectionInterface } from "src/interfaces/forms/ExemptionPropertyDamagedByDisasterForm/exemption-property-damaged-third-section.interface";
import ExemptionPropertyDamagedFormPDFView from "src/pages/Shared/ExemptionPropertyDamagedFormPDFView/ExemptionPropertyDamagedFormPDFView";
import ExemptionPropertyDamagedFormFirstSection from "./ExemptionPropertyDamagedFormFirstSection";
import ExemptionPropertyDamagedFormSecondSection from "./ExemptionPropertyDamagedFormSecondSection";
import ExemptionPropertyDamagedFormThirdSection from "./ExemptionPropertyDamagedFormThirdSection";
import ExemptionPropertyDamagedFormFourthSection from "./ExemptionPropertyDamagedFormFourthSection";
import ExemptionPropertyDamagedFormFifthSection from "./ExemptionPropertyDamagedFormFifthSection";
import ExemptionPropertyDamagedFormSixthSection from "./ExemptionPropertyDamagedFormSixthSection";
import ExemptionPropertyDamagedFormSeventhSection from "./ExemptionPropertyDamagedFormSeventhSection";
import ExemptionPropertyDamagedFormEighthSection from "./ExemptionPropertyDamagedFormEighthSection";
import { FormHeader } from "../Shared/FormHeader/FormHeader";
import { submitted } from "src/constants/submission-form-status-constants";
import { useIsFormActive } from "../useIsFormActive";
import { ExemptionPropertyDamagedDisclaimer } from "./ExemptionPropertyDamagedDisclaimer";

interface FormEntry {
  formEntryId?: number;
  isAdminPreview?: boolean;
  formId?: number;
}

export default function ExemptionPropertyDamagedForm(props: FormEntry): JSX.Element {
    const { isAuthorized } = AuthService.getInstance();

    const { isAdminPreview, formEntryId, formId } = props;
    const { formState, formDispatch } = useFormContext();
    const { selectedFormDispatch, selectedFormState } = useSelectedFormContext();
    const { loading } = formState;
    const { isLoading } = selectedFormState;
    const [formDataFields, setFormDataFields] = useState<Array<IFormFiledInterface>>();
    const [formEntry, setFormEntry] = useState<IFormEntryModel>();
    const formSettings = useMemo(() => {
      let formSettings = selectedFormState.formSettings ?? undefined;
      if (
          !isAuthorized ||
          isAdminPreview ||
          selectedFormState.formEntry?.submissionStatus == submitted
       ) {
        formSettings = { ...formSettings, isReadOnly: true };
       }
       return formSettings;
    }, [selectedFormState.formSettings, selectedFormState.formEntry, isAuthorized, isAdminPreview]);

    const [formFirstSectionDataFields, setFormFirstSectionDataFields] = useState<IExemptionPropertyDamagedFormFirstSection>();
    const [formSecondSectionDataFields, setFormSecondSectionDataFields] = useState<IExemptionPropertyDamagedFormSecondSection>();
    const [formThirdSectionDataFields, setFormThirdSectionDataFields] = useState<IExemptionPropertyDamagedFormThirdSection>();
    const [formFourthSectionDataFields, setFormFourthSectionDataFields] = useState<IExemptionPropertyDamagedFormFourthSection>();
    const [formFifthSectionDataFields, setFormFifthSectionDataFields] = useState<IExemptionPropertyDamagedFormFifthSection>();
    const [formSixthSectionDataFields, setFormSixthSectionDataFields] = useState<IExemptionPropertyDamagedFormSixthSection>();
    const [formSeventhSectionDataFields, setFormSeventhSectionDataFields] = useState<IExemptionPropertyDamagedFormSeventhSection>();

    const [firstSectionIsValid, setFirstSectionIsValid] = useState<boolean>(false);
    const [secondSectionIsValid, setSecondSectionIsValid] = useState<boolean>(false);
    const [thirdSectionIsValid, setThirdSectionIsValid] = useState<boolean>(false);
    const [fourthSectionIsValid, setFourthSectionIsValid] = useState<boolean>(false);
    const [fifthSectionIsValid, setFifthSectionIsValid] = useState<boolean>(false);
    const [sixthSectionIsValid, setSixthSectionIsValid] = useState<boolean>(false);
    const [seventhSectionIsValid, setSeventhSectionIsValid] = useState<boolean>(false);

    const [isFormValid, setIsFormValid] = useState<boolean>(false);

    const { isFormActive } = useIsFormActive(
      isAuthorized,
      isAdminPreview,
      formSettings,
      "AdditionalDocuments",
      selectedFormState.formFields,
      formSixthSectionDataFields?.AdditionalDocuments
    );
  const [showPrompt, confirmNavigation, cancelNavigation, setDisablePrompt] = useCallbackPrompt(isFormActive);
  
  const [showDisclaimer, setShowDisclaimer] = useState(false);

    useEffect(() => {
      setIsFormValid(
        firstSectionIsValid &&
        secondSectionIsValid &&
        thirdSectionIsValid &&
        fourthSectionIsValid &&
        fifthSectionIsValid &&
        sixthSectionIsValid &&
        seventhSectionIsValid)
    }, [
      firstSectionIsValid,
      secondSectionIsValid,
      thirdSectionIsValid,
      fourthSectionIsValid,
      fifthSectionIsValid,
      sixthSectionIsValid,
      seventhSectionIsValid
    ])

    useEffect(() => {
      return () => {
        selectedFormDispatch({
          type: SelectedFormActionsEnum.CLEAR,
          payload: {
            errorMessage: undefined,
            isLoading: undefined,
            formFields: undefined,
            successMessage: undefined,
            form: undefined,
            formSettings: undefined,
            formEntry: undefined,
            status: SelectedFormActionsEnum.CLEAR
          },
        });
      }
    }, []);


    useEffect(() => {
          const disclaimerFormText = formState.forms?.find(x => x.name === TemporaryExemptionPropertyDamagedbyDisasterFormName)?.disclaimerText ?? "";
          if (!formEntryId && disclaimerFormText.trim().length > 0) {
            setShowDisclaimer(true);
          }
        }, [formEntryId, formState?.forms]);

    useEffect(() => {
      if (!formState.forms.length) {
        onLoadForms(formDispatch);
      }
    }, []);

    useEffect(() => {
      const stateFormId = formState?.forms?.find(x => x.name == TemporaryExemptionPropertyDamagedbyDisasterFormName)?.id ?? formId;

      if (stateFormId && isAuthorized) {
        if (formEntryId) {
          getSelectedFormEntryDataHelper(selectedFormDispatch, stateFormId, formEntryId);
        } else {
          getSelectedFormDataHelper(selectedFormDispatch, stateFormId);
        }
      }
    }, [formState.forms]);

    useEffect(() => {
      if (selectedFormState?.formEntry) {
        if (selectedFormState.form?.name) {
          setFormEntry({
            ...selectedFormState?.formEntry,
            formName: selectedFormState.form?.name
          });
        } else {
          setFormEntry(selectedFormState.formEntry)
        }
      }
    }, [selectedFormState.formEntry, selectedFormState.form]);

    function ClearData() {
      setFormDataFields([]);
      setFormEntry(undefined);
      setFormFirstSectionDataFields({});
      setFormSecondSectionDataFields({});
      setFormThirdSectionDataFields({});
      setFormFourthSectionDataFields({});
      setFormFifthSectionDataFields({});
      setFormSixthSectionDataFields({});
      setFormSeventhSectionDataFields({});
      setFirstSectionIsValid(false);
      setSecondSectionIsValid(false);
      setThirdSectionIsValid(false);
      setFourthSectionIsValid(false);
      setFifthSectionIsValid(false);
      setSixthSectionIsValid(false);
      setSeventhSectionIsValid(false);

      setDisablePrompt(false);
    }

    useEffect(() => {
      if (selectedFormState.status === SelectedFormActionsEnum.CLEAR) {
        ClearData();
        return;
      }

      setFormDataFields(selectedFormState.formFields);
      const FirstSection: IExemptionPropertyDamagedFormFirstSection = ExemptionPropertyDamagedFormFirstSectionInterface();
      const SecondSection: IExemptionPropertyDamagedFormSecondSection = ExemptionPropertyDamagedFormSecondSectionInterface();
      const ThirdSection: IExemptionPropertyDamagedFormThirdSection = ExemptionPropertyDamagedFormThirdSectionInterface();
      const FourthSection: IExemptionPropertyDamagedFormFourthSection = ExemptionPropertyDamagedFormFourthSectionInterface();
      const FifthSection: IExemptionPropertyDamagedFormFifthSection = ExemptionPropertyDamagedFormFifthSectionInterface();
      const SixthSection: IExemptionPropertyDamagedFormSixthSection = ExemptionPropertyDamagedFormSixthSectionInterface();
      const SeventhSection: IExemptionPropertyDamagedFormSeventhSection = ExemptionPropertyDamagedFormSeventhSectionInterface();

      selectedFormState?.formFields.forEach((f) => {
        let value;
        switch (f.type) {
          case "boolean":
          case "object":
            value = JSON.parse(f.value);
            break;
          case "string":
            value = f.value.trim();
            break;
          case "number":
            value = +f.value;
            break;
        }

        switch(true) {
          case f.name in FirstSection:
            (FirstSection as any)[f.name] = value;
            break;
          case f.name in SecondSection:
            (SecondSection as any)[f.name] = value;
            break;
          case f.name in ThirdSection:
            (ThirdSection as any)[f.name] = value;
            break;
          case f.name in FourthSection:
            (FourthSection as any)[f.name] = value;
            break;
          case f.name in FifthSection:
            (FifthSection as any)[f.name] = value;
            break;
          case f.name in SixthSection:
            (SixthSection as any)[f.name] = value;
            break;
          case f.name in SeventhSection:
            (SeventhSection as any)[f.name] = value;
            break;
        }
      });
      if (selectedFormState.formFields.length > 0) {
        setFormFirstSectionDataFields(FirstSection);
        setFormSecondSectionDataFields(SecondSection);
        setFormThirdSectionDataFields(ThirdSection);
        setFormFourthSectionDataFields(FourthSection);
        setFormFifthSectionDataFields(FifthSection);
        setFormSixthSectionDataFields(SixthSection);
        setFormSeventhSectionDataFields(SeventhSection);
      }
    }, [selectedFormState.formFields]);

    useFormSectionDataFields({
      sectionFields: formFirstSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formSecondSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formThirdSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formFourthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formFifthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formSixthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formSeventhSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    const navigate = useNavigate();

    function saveHandler() {
      setDisablePrompt(true);
      const temp = {
        ...formEntry,
        formName: selectedFormState.form?.name,
        submissionStatus: "Saved",
      } as IFormEntryModel;
      setFormEntry(temp);
      if (selectedFormState.form?.name) {
        saveFormHelper(selectedFormDispatch, selectedFormState.form?.name, temp, formDataFields!, navigate);
      }
    }

    function setFormEntryBase64Url(url: string) {
      setFormEntry({ ...formEntry, pdfBase64Url: url } as IFormEntryModel);
    }

    function submitHandler() {
      const temp = {
        ...formEntry,
        formName: selectedFormState.form?.name,
        submissionStatus: "Submitted",
      } as IFormEntryModel;
      setFormEntry(temp);
      setDisablePrompt(true);

      if (selectedFormState.form?.name) {
        saveFormHelper(selectedFormDispatch, selectedFormState.form?.name, temp, formDataFields!, navigate);
      }
    }

    const [visible, setVisible] = useState<boolean>(false);
    const [submit, setSubmit] = useState<boolean>(false);

    const toggleDialog = () => {
      setVisible(!visible);
    };

    const toggleSubmitDialog = () => {
      setSubmit(!submit);
      setVisible(!visible);
    };

    const dialogTitle = (
      <div>
        {submit && !formEntry?.underRevision && formEntry?.submissionStatus != "Submitted" && (
          <button className="button" onClick={submitHandler}>
            submit form
          </button>
        )}
      </div>
    );

    return <>
      <div className={classes.form}>
        {visible && (
          <Dialog
            className="customFormDialog"
            title={dialogTitle}
            onClose={submit ? toggleSubmitDialog : toggleDialog}
            width={"70vw"}
            height={"90vh"}
          >
            <ExemptionPropertyDamagedFormPDFView
              getPdfBase64Url={setFormEntryBase64Url}
              formDataFieldsFirstSection={formFirstSectionDataFields}
              formDataFieldsSecondSection={formSecondSectionDataFields}
              formDataFieldsThirdSection={formThirdSectionDataFields}
              formDataFieldsFourthSection={formFourthSectionDataFields}
              formDataFieldsFifthSection={formFifthSectionDataFields}
              formDataFieldsSixthSection={formSixthSectionDataFields}
              formDataFieldsSeventhSection={formSeventhSectionDataFields}
            />
          </Dialog>
        )}

        <FormHeader
          formName={TemporaryExemptionPropertyDamagedbyDisasterFormName}
          isAdminPreview={isAdminPreview}
          isAuthorized={isAuthorized}
          formEntry={formEntry}
          formSettings={formSettings}
          isFormValid={isFormValid}
          onPrint={() => toggleDialog()}
          onSave={() => saveHandler()}
          onSubmit={() => toggleSubmitDialog()}
        />

        <ExemptionPropertyDamagedFormFirstSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formFirstSectionDataFields}
          setFormDataFields={setFormFirstSectionDataFields}
          setFormIsValid={setFirstSectionIsValid}
        />

        <ExemptionPropertyDamagedFormSecondSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formSecondSectionDataFields}
          setFormDataFields={setFormSecondSectionDataFields}
          setFormIsValid={setSecondSectionIsValid}
        />

        <ExemptionPropertyDamagedFormThirdSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formThirdSectionDataFields}
          setFormDataFields={setFormThirdSectionDataFields}
          setFormIsValid={setThirdSectionIsValid}
        />

        <ExemptionPropertyDamagedFormFourthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formFourthSectionDataFields}
          setFormDataFields={setFormFourthSectionDataFields}
          setFormIsValid={setFourthSectionIsValid}
        />

        <ExemptionPropertyDamagedFormFifthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formEntry={formEntry}
          formDataFields={formFifthSectionDataFields}
          setFormDataFields={setFormFifthSectionDataFields}
          setFormIsValid={setFifthSectionIsValid}
        />

        <ExemptionPropertyDamagedFormSixthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formSixthSectionDataFields}
          setFormDataFields={setFormSixthSectionDataFields}
          setFormIsValid={setSixthSectionIsValid}
          selectedFormDispatch={selectedFormDispatch}
          formEntry={formEntry}
        />

        <ExemptionPropertyDamagedFormSeventhSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formSeventhSectionDataFields}
          setFormDataFields={setFormSeventhSectionDataFields}
          setFormIsValid={setSeventhSectionIsValid}
        />

        <ExemptionPropertyDamagedFormEighthSection/>

        {(!isFormValid && !formSettings?.isReadOnly) &&
          <div className={classes.invalidForm}>
            <h2>Please Fill All Required Fields in Steps:</h2>
            {!firstSectionIsValid &&
              <div className={classes.item}>
                1.   Filing Information
              </div>}
            {!secondSectionIsValid &&
              <div className={classes.item}>
                2.   Property Owner Information
              </div>}
            {!thirdSectionIsValid &&
              <div className={classes.item}>
                3.   Authorized Representative Information
              </div>}
            {!fourthSectionIsValid &&
              <div className={classes.item}>
                4.   Property Information
              </div>}
            {!fifthSectionIsValid &&
              <div className={classes.item}>
                5.   Damage Description
              </div>}
            {!sixthSectionIsValid &&
              <div className={classes.item}>
                6.   Additional Documents to be Provided
              </div>}
            {!seventhSectionIsValid &&
              <div className={classes.item}>
                7.   Certification and Signature
              </div>}
          </div>}

        {isAuthorized && !isAdminPreview &&
          !formSettings?.isReadOnly &&
          formEntry?.submissionStatus != "Submitted" && (
            <span className="buttons-group">
              <button disabled={!isFormValid}
                className="button"
                onClick={() => toggleSubmitDialog()}
              >
                <i className="fa fa-tasks fa-fw"></i>
                Review & Submit
              </button>
            </span>
          )}
      </div>
      {showDisclaimer && (
            <ExemptionPropertyDamagedDisclaimer 
                disclaimerText={formState?.forms?.find(x => x.name == TemporaryExemptionPropertyDamagedbyDisasterFormName)?.disclaimerText?.trim() || ""}
                onClose={() => setShowDisclaimer(false)} />)}
      {(loading || isLoading) && <CustomLoader />}
      {showPrompt && isAuthorized && (!loading && !isLoading) && (
        <UnsavedFormDialog
          onConfirm={confirmNavigation}
          onCancel={cancelNavigation}
        />
      )}
    </>
  }